<template>
  <div>
    <el-form inline>
      <el-form-item label="">
        <selectCompany :id.sync="condition.company_id" />
      </el-form-item>

      <el-form-item label="">
        <selectClient
          :client-id.sync="condition.client_id"
          :company-id="condition.company_id"
          @onSelect="onSelectClient"
        />
      </el-form-item>

      <el-form-item label="">
        <selectMvm
          :id.sync="condition.mvm_id"
          :client-id="condition.client_id"
          :company-id="condition.company_id"
          @onSelect="onSelectMvm"
        />
      </el-form-item>

      <el-form-item label="">
        <selectDate @onSelect="onDateChange" />
      </el-form-item>
      <slot />
    </el-form>
  </div>
</template>
<script>
import selectCompany from '@/components/select/companies.vue'
import selectClient from '@/components/select/client.vue'
import selectMvm from '@/components/select/mvm.vue'
import selectDate from '@/components/select/datePicker.vue'
const methods = {
  async onSelectCompany() {},
  async onSelectClient(id) {},
  async onSelectMvm() {},
  async onDateChange(date) {
    this.condition.date = date
  }
}
export default {
  components: {
    selectCompany,
    selectClient,
    selectMvm,
    selectDate
  },
  data() {
    return {
      condition: {
        company_id: 1,
        client_id: null,
        mvm_id: null,
        date: null
      }
    }
  },
  watch: {
    condition: {
      handler: function() {
        this.$emit('onSearch', this.condition)
      },
      deep: true
    }
  },
  created() {
    this.$emit('onSearch', this.condition)
  },
  methods
}
</script>
